import Physics from 'physicsjs';

const PhysicsNoConflict = Physics.noConflict();

export default PhysicsNoConflict;
